import classNames from "classnames";
import AscImage from "../AscImage/AscImage";
import styles from "./AscAvatar.module.scss";
import SampleAvatar from "../../assets/images/sample-avatar-1.png";
import { AscAvatarProps } from "./AscAvatar.type";
import { FlagSingapore, FlagUSA } from "../AscIcons";

export default function AscAvatar({
  alt = "avatar",
  size = "medium",
  className,
  wrapperClassName,
  flagClassName,
  flag,
  src,
  ...rest
}: AscAvatarProps) {
  const getFlag = (flag: string) => {
    switch (flag) {
      case "USA":
        return <FlagUSA data-testid={"test-flag"} />;
      case "Singapore":
        return <FlagSingapore />;
      default:
        return <AscImage className={styles.flagImage} src={flag} />;
    }
  };

  return (
    <div
      className={classNames(
        styles.element,
        { [styles.withFlag]: flag },
        wrapperClassName
      )}
    >
      <AscImage
        className={classNames(
          {
            [styles.small]: size === "small",
            [styles.medium]: size === "medium",
            [styles.large]: size === "large",
          },
          styles.ground,
          className
        )}
        alt={alt}
        fallbackImageUrl={SampleAvatar}
        src={src || ""}
        {...rest}
      />

      {flag && getFlag(flag) && (
        <div className={classNames(styles.flag, flagClassName)}>
          {getFlag(flag)}
        </div>
      )}
    </div>
  );
}
